import { PlayArrow } from '@mui/icons-material';
import { On3IconVideo } from '@on3/icons';
import dynamic from 'next/dynamic';
import { useState } from 'react';

import styles from './VideoPlayer.module.scss';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

interface IVideoPlayerProps {
  sourceUrl?: string | null;
  thumbnail?: string | null;
  title?: string | null;
}

export const VideoPlayer = ({
  sourceUrl,
  thumbnail,
  title,
}: IVideoPlayerProps) => {
  const [showPlayer, setShowPlayer] = useState(false);

  // // React player doesn't handle hudl, so we need to use their custom embed
  if (!sourceUrl) {
    return <On3IconVideo className={styles.videoIcon} />;
  }

  if (thumbnail && !showPlayer) {
    return (
      <button
        className={styles.thumbnail}
        onClick={() => setShowPlayer(true)}
        type="button"
      >
        <img alt={title || 'video'} src={thumbnail} />
        <PlayArrow className={styles.play} />
      </button>
    );
  }

  if (sourceUrl?.includes('hudl.com')) {
    let src = sourceUrl;

    if (!/^https?:\/\//.test(sourceUrl)) {
      src = `//${sourceUrl.replace(/^https?:\/\//, '')}`;
    }

    src = src.replace('hudl.com/video', 'hudl.com/embed/video');

    return (
      <iframe
        allow="autoplay"
        allowFullScreen
        className={styles.reactPlayer}
        height="100%"
        src={`${src}?autoplay=${showPlayer ? 'true' : 'false'}`}
        title={title || 'video'}
        width="100%"
      />
    );
  }

  return (
    <ReactPlayer
      className={styles.reactPlayer}
      controls={true}
      height="100%"
      muted={showPlayer ? true : false}
      playing={showPlayer ? true : false}
      title={title}
      url={sourceUrl}
      width="100%"
    />
  );
};
